import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Router from 'sites/routes/router';
import ReactDOM from 'react-dom';

import { push } from 'connected-react-router';
// import Router from 'sites/routes/router';
import ChatNotification from 'sites/views/chat/notification';
import { initChatSocket } from 'sites/utils/socket';
import { clickedInChat, createPrivateMessage } from 'sites/api/AuthApi';
import LimitModal from 'sites/views/wallet-tip-modules/limit-modal';
import ChatList from 'sites/views/chat/list';
import { checkWalletLimit, uploadAudioRecord } from 'sites/api/AuthApi';
import {
   checkWalletLimitStart,
   checkWalletLimitCompleted,
   checkWalletLimitFailed,
   setWalletLimitState,
} from 'sites/state/modules/wallet/actions';
import {
   walletLimitModalDataSelector,
} from 'sites/state/modules/wallet/selectors';
import {
   screenWidthSelector,
   authUserSelector,
   siteInfoSelector,
   walletBalanceSelector,
   onlineStreamSelector,
   isOfflineModeSelector,
} from 'sites/state/modules/common/selectors';
import {
   initDataSelector as currentLiveStreamSelector,
} from 'sites/state/modules/livestream/selectors'
import {
   isFetchingInitSelector,
   isFetchingMessageSelector,
   isNextFetchingMessageSelector,
   likedMemberByMessageSelector,
   onlineUsersSelector,
   isSocketConnectedSelector,
   groupChatSelector,
   privateChatSelector,
   settingsSelector,
   groupChatTypersMessageSelector,

   privateMessagesSelector,
   publicMessagesSelector,
   activeMessageTabSelector,
   showNavigationListSelector,

   privateChatTypersMessageSelector,

   mutedInfoSelector,
   chatPanelSelector,
   initedSelector,
   hiddeChatIconSelector,
} from 'sites/state/modules/chat/selectors';
import {
   setOnlineUsersAction,
   setSocketConnectedAction,
   chatInitCompleted,
   setMessagLike,
   deleteMessage,
   addNewMessage,
   updateMessageData,
   updateConverstionData,
   updatePrivateConversation,
   setMutedMemberInfo,
   setChatPanelAction,
   setChatSettings,
   setActiveTab,
}  from 'sites/state/modules/chat/actions'
import { onClickChat } from 'sites/state/modules/chat/actions';
import {
   chatInitOperation,
   fetchMessagesOperation,
   fetchNextMessagesOperation,
   fetchMessageLikedMembersOperation,
   openClosedConversationOperation,
} from 'sites/state/modules/chat/operations';
import OnlineMembersLlst from 'common/components/modules/chat/chat-likes-modal';
import {
   tipModalDataSelector,
   isCheckLimitFetchingSelector,
} from 'sites/state/modules/tip/selectors';
import {
   setModalState as setTipModalState,
} from 'sites/state/modules/tip/actions';
// import { push } from 'connected-react-router';
import { getUserStatusType } from 'sites/utils/utils.js';
import DateFormatter from 'common/utils/DateFormatter';
import ChatHepler from 'common/utils/chat';
import toast from "common/utils/toast";
import { currentLocationPathSelector } from 'sites/state/modules/router/selectors';
import TipMeContainer from 'sites/containers/pages/tip';
import { getWalletBalanceOperation } from 'sites/state/modules/common/operations';
import { downloadMediaOperation } from 'sites/state/modules/media-resources/operations';
import {
   chatInit,
} from 'sites/api/AuthApi';
import {
   getObjectUrl,
} from 'sites/api/GuestApi';
import { fetchPurchaseMethodsOperation } from 'sites/state/modules/purchase-send/operations';
import WalletModal from 'sites/views/wallet-tip-modules/wallet-tip-modal';
import { paymentSend } from 'sites/state/modules/purchase-send/operations';

import { initWalletOperation } from 'sites/state/modules/wallet/operations';
import { isFetchingSelector as isFetchingWalletAmountSelector } from 'sites/state/modules/wallet/selectors';
import { amountDataSelector } from 'sites/state/modules/wallet/selectors';
import { isFetchingMessagesSelector as isFetchingLiveStreamMessagesSelector, streamConversationSelector, initDataSelector as initLivestreamDataSelector } from 'sites/state/modules/livestream/selectors';

import { setSendModalState } from 'sites/state/modules/purchase-send/actions';
import {
   modalTypeSelector,
   isOpenSendModalSelector,
   isFetchingSendSelector as isFetchingWalletPayedSelector,
   isNotEnoughtBalanceSelector,
   isSendSelector,
   modalKeySelector as walletModalKeySelector,
   priceSelector,
   paymentButtonLoadingSelector,
   paymentButtonResourceIdSelector,
   mainMessageIdSelector,
} from 'sites/state/modules/purchase-send/selectors';
import { isEmpty as isEmptyObject } from 'lodash'
import {
   updateWalletBalanc,
   setIsOfflineModeAction,
} from 'sites/state/modules/common/actions';

import Auth from 'sites/utils/Auth'

import QueryParams from 'sites/utils/QueryParams';
import SendModal from 'sites/containers/pages/purchase-send';
import { history } from 'sites/state/store';
import LiveStreamConversation from 'sites/containers/pages/live-stream/studio/online-chat';
import { setReferrerUrl } from 'sites/utils/utils.js';
import randomstring from 'randomstring';
import cx from 'classnames';
import { closePollModalAction, openClosePollConfirmDialogAction } from 'sites/state/modules/polls/actions';
import { openActivePollModalOperation } from 'sites/state/modules/polls/operations';

class ChatNotificationContainer extends Component {
   previousY = 0
   Timeout = null
   draftMessage = {}
   state = {
      openChatModal: false,
      animationClass: null,
      animateSend: 'up',
      openOnlineMebersModal: false,
      selectedAmount: null,
      walletModalAnimate: 'up',
      isAddProcessingFees: true,
   }
   static propTypes = {
      onClickChat: PropTypes.func,
      authUser: PropTypes.object,
      screenWidth: PropTypes.number,
      init: PropTypes.func,
      isFetchingInit: PropTypes.bool,
      fetchMessages: PropTypes.func,
      fetchNextMessages: PropTypes.func,
      isNextFetchingMessage: PropTypes.bool,
      isFetchingMessage: PropTypes.bool,
      fetchMessageLikedMembers: PropTypes.func,
      goTo: PropTypes.func,
      likedMemberByMessage: PropTypes.object,
      siteInfo: PropTypes.object,
      onlineUsers: PropTypes.array,
      setOnlineUsersAction: PropTypes.func,
      setSocketConnectedAction: PropTypes.func,
      isSocketConnected: PropTypes.bool,
      setTyper: PropTypes.func,
      privateChat: PropTypes.object,
      groupChat: PropTypes.object,
      settings: PropTypes.object,
      groupChatTypersMessage: PropTypes.string,
      setMessagLike: PropTypes.func,
      privateMessages: PropTypes.object,
      publicMessages: PropTypes.object,
      activeMessageTab: PropTypes.object,
      deleteMessage: PropTypes.func,
      addNewMessage: PropTypes.func,
      updateMessageData: PropTypes.func,
      updateConverstionData: PropTypes.func,
      showNavigationList: PropTypes.bool,
      privateChatTypersMessage: PropTypes.string,
      updatePrivateConversation: PropTypes.func,
      mutedInfo: PropTypes.object,
      chatPanel: PropTypes.object,
      setMutedMemberInfo: PropTypes.func,
      setChatPanel: PropTypes.func,
      setChatSettings: PropTypes.func,
      inited: PropTypes.bool,
      locationPath: PropTypes.string,
      setTipModalState: PropTypes.func,
      tipModalData: PropTypes.object,
      isCheckLimitFetching: PropTypes.bool,
      paymentSend: PropTypes.func,

      purchaseModalType: PropTypes.string,
      isOpenPurchaseModal: PropTypes.bool,
      isNotEnoughtBalance: PropTypes.bool,
      isFetchingWalletPayed: PropTypes.bool,
      modalKey: PropTypes.string,
      amountData: PropTypes.array,
      isFetchingWalletAmount: PropTypes.bool,
      setSendModalState: PropTypes.func,
      initWalllet: PropTypes.func,
      price: PropTypes.number,
      fetchPurchaseMethods: PropTypes.func,
      updateWalletBalanc: PropTypes.func,
      walletBalance: PropTypes.number,
      getWalletBalance: PropTypes.func,
      walletLimitModalData: PropTypes.object,
      checkWalletLimitStart: PropTypes.func,
      checkWalletLimitCompleted: PropTypes.func,
      checkWalletLimitFailed: PropTypes.func,
      setWalletLimitState: PropTypes.func,
      onlineStream: PropTypes.bool,
      paymentButtonLoading: PropTypes.bool,
      hiddeChatIcon: PropTypes.bool,
      isFetchingLiveStreamMessages: PropTypes.bool,
      streamConversation: PropTypes.object,
      currentLiveStream: PropTypes.object,
      setActiveTab: PropTypes.func,
      showOnlyViews: PropTypes.bool,
      downloadFile: PropTypes.func,
      paymentButtonResourceId: PropTypes.string,
      openClosedConversation: PropTypes.func,
      setIsOfflineModeAction: PropTypes.func,
      isOfflineMode: PropTypes.bool,
      mainMessageId: PropTypes.any,
      openPollModal: PropTypes.func,
      closePollModal: PropTypes.func,
      openClosePollConfirmDialog: PropTypes.func,
      initLivestreamData: PropTypes.object,
   };

   openChatTimeOut = ''
   socket = null
   timeOut = null
   privateThreadTypersRemovers = {}
   publicThreadTypersRemovers = {}
   messagesContentRef = React.createRef()
   scrollPositions = {}
   chatDropDownState = false
   longPolingTime = 0
   loaderText = null
   isRedirect = false
   messageId = null
   streamPrice = null
   messageType = null
   unlisten = null
   _isMounted = false
   promoMessage = null
   modalType = null
   chatPeyParUsingOnlyWallet = true
   darftNewMessage = {}

   componentDidMount(){
      this.onUpdateRecordStatus(null);
      this.historylisten()
      const { authUser } = this.props;
      if(!authUser && !Auth.isTokenExists()) {
         return
      }
      // const { hiddeChatIcon } = this.props
      // if(!!hiddeChatIcon) {
      //    this.initChatSettings(false)
      // }
      if(authUser) {
         this.fetchChat(false)
      }

      this.chatModalState()
      this._initConnection();
      this._bindEvents();

   }

   historylisten = () => {
      this.unlisten = history.listen((location, action) => {
         const {  onlineStream, locationPath } = this.props;
         if('POP' === action){
            if(!QueryParams.getParam('conversation')) {
               const { setChatPanel } = this.props
               setChatPanel({ isOpen: false, closeChatMessages: false, animationClass: {} })
            }
         }
         if(onlineStream && !!Router.route('LIVE_STREAM_STUDIO').match(locationPath) && !Router.route('LIVE_STREAM_STUDIO').match(location.pathname)) {
            this.isRedirect = true;
            const { setChatPanel } = this.props
            setChatPanel({ isOpen: false, closeChatMessages: false, animationClass: {} })
         }

      });
   }

   componentWillUnmount() {
      const { setChatPanel, chatPanel, screenWidth } = this.props;
      if(screenWidth >= 1025 && !this.isRedirect) {
         setChatPanel({
            isOpen: chatPanel.isOpen,
            closeChatMessages: chatPanel.isOpen,
            isMobile: screenWidth < 1025,
            animationClass: {
               transform: chatPanel.isOpen ? 'translateX(0)' : 'translateX(100%)',
               WebkitTransform: chatPanel.isOpen ? 'translateX(0)' : 'translateX(100%)',
            },
         })

      }
      clearTimeout(this.Timeout)
      clearTimeout(this.timeOut)
      ChatHepler.inputState(false)
      this.unlisten()
      // clearTimeout(this.longPolingTime)
   }

   chatModalState = () => {
      const { screenWidth } = this.props
      if(screenWidth < 1024){
         if(!!QueryParams.getParam('conversation')){
            const {
               isFetchingInit,
               groupChat,
               privateChat,
               groupChatTypersMessage,
               settings,
               privateChatTypersMessage,
            } = this.props
            if(!isFetchingInit) {
               let item = {}
               if(+QueryParams.getParam('conversation') === groupChat.chat_room_id) {
                  item = { ...groupChat, isGroup: true, user_is_typing: !!groupChatTypersMessage, conversation_is_not_active: !settings.is_group_chat_active, type: 'public' }
               } else {
                  item = { ...privateChat, user_is_typing: !!privateChatTypersMessage, conversation_is_not_active: !settings.is_private_chat_active, type: 'private'  }
               }
               this.onClickChat(item, false, true)
            } else if(!!QueryParams.getParam('conversation')){
               const { setChatPanel } = this.props
               history.goBack()
               setChatPanel({ isOpen: false, closeChatMessages: false, animationClass: {} })
            }
         } else {
            const { setChatPanel } = this.props
            setChatPanel({ isOpen: false, closeChatMessages: false, animationClass: {} })
         }
      }
   }
   setSoketEmitData = data => {
      const { activeMessageTab: { id: conversationId } } =  this.props
      let result = { ...data, conversationId }
      return result
   }

   getConverstionType = id => {
      const {
         groupChat, privateChat,
      } = this.props
      let type = null
      if(groupChat.chat_room_id === id){
         type = 'public'
      }
      if(privateChat.chat_room_id === id){
         type = 'private'
      }
      return type
   }
   _bindEvents = () => {
      const { socket } = this;
      socket.removeAllListeners('connect');
      socket.removeAllListeners('connect_error');
      socket.removeAllListeners('disconnect');
      socket.removeAllListeners('ready');
      socket.removeAllListeners('users:online');
      socket.removeAllListeners('user:online');
      socket.removeAllListeners('user:offline');
      socket.removeAllListeners('typing');
      socket.removeAllListeners('message:like');
      socket.removeAllListeners('message:delete');
      socket.removeAllListeners('message:send');

      socket.removeAllListeners('message:update');
      socket.removeAllListeners('conversation:read');
      socket.removeAllListeners('user:mute');
      socket.removeAllListeners('user:unmute');
      socket.removeAllListeners('conversation:seen');
      socket.removeAllListeners('offline-mode');

      socket.on('connect', () => {
         socket.emit('online')
      });

      socket.on('connect_error', () => {
         this.setSocketConnected(false)
      });

      socket.on('disconnect', (r) => {
         this.setSocketConnected(false)
      });

      socket.on('ready', () => {
         this.setSocketConnected(true)
      });

      socket.on('users:online', (users) => {
         this.setOnlineMembers(users)
      });

      socket.on('user:online', (user) => {
         if(!user) {
            return
         }
         this.setOnlineMembers(user, 'push')
      });

      socket.on('user:offline', (user) => {
         this.setOnlineMembers(user, 'pop')
      });

      socket.on('typing', (data) => {
         const { authUser, screenWidth, activeMessageTab } = this.props
         const {
            conversationId,
            typingType,
         } = data
         let type = this.getConverstionType(conversationId)
         if(data.user.uuid !== authUser.uuid) {
            this.handleTyping(data.conversationId, data.user, type, 'type', typingType)
         }
         if(activeMessageTab && activeMessageTab.id === conversationId) {
            const dialogue = document.querySelector(`#messages-content-${ conversationId }`)
            if(dialogue) {
               const { scrollHeight, clientHeight, scrollTop } = dialogue
               let diff =  (scrollHeight - clientHeight) - scrollTop
               if(diff < 110) {
                  ChatHepler.syncDialogueScroll(null, conversationId)
               }
               if(screenWidth > 1024) {
                  ChatHepler.inputState()
               }
            }
         }
      });

      socket.on('message:like', (data) => {
         this.handleLikeMessage(data)
      });

      socket.on('message:delete', (data) => {
         this.handleDeleteMessage(data)
      });
      socket.on('message:send', (data) => {
         const {
            message, conversationId, user,
         } = data
         const { authUser, activeMessageTab, screenWidth } = this.props
         const messageData = { ...message, user, parent: message.parentMessage, sent_at: message.sentAt, unlock_details: message.unlockDetails }
         let type = this.getConverstionType(conversationId)
         this.handleTyping(data.conversationId, data.user, type, 'stop')
         const { updatePrivateConversation, privateChat, groupChat } =  this.props
         if(groupChat.chat_room_id !== conversationId && !privateChat.chat_room_id) {
            updatePrivateConversation(conversationId)
            type = 'private'
         }
         const isMyMessage =  user.uuid === authUser.uuid
         this.handleAddNewMessage(messageData, type, isMyMessage)
         if(activeMessageTab && activeMessageTab.id === conversationId) {
            const dialogue = document.querySelector(`#messages-content-${ conversationId }`)
            if(dialogue) {
               const { scrollHeight, clientHeight, scrollTop } = dialogue
               let diff =  (scrollHeight - clientHeight) - scrollTop
               if(diff < 110) {
                  ChatHepler.syncDialogueScroll(null, conversationId)
               }
               if(screenWidth > 1024) {
                  ChatHepler.inputState()
               }
            }
         }
      });

      socket.on('message:update', (data) => {
         const {
            message, conversationId, unlock_details,
         } = data

         let type = this.getConverstionType(!!Number(conversationId) ? +conversationId : conversationId)

         let messageData = message

         if(!!unlock_details) {
            messageData.unlock_details = unlock_details
         }

         this.handleUpdateThisMessage(message.id, { ...messageData }, type)
      });

      socket.on('conversation:read', (data) => {
         const {
            conversationId,
         } = data
         this.handleReadConverstionId(conversationId)
      });
      socket.on('user:mute', (data) => {
         const { setMutedMemberInfo } =  this.props
         let info = {
            muted_period_in_seconds: data.muteInfo.mute_period_in_seconds,
            muted_since: data.muteInfo.muted_since,
         }
         setMutedMemberInfo({ ...info, isMuted: true, isMutedModal: true })
      });
      socket.on('user:unmute', (data) => {
         const { setMutedMemberInfo } =  this.props
         let info = {
            muted_period_in_seconds: null,
            muted_since: null,
         }
         setMutedMemberInfo({ ...info, isMuted: false, isMutedModal: false })

      });
      socket.on('conversation:seen', (data) => {
         const state = {
            unread_messages_count_of_second_participant: 0,
            last_seen_of_second_participant: data.lastSeenTime,
            conversationId: data.conversationId,
         }
         this.handleSeenConverstionId(state)
      });
      socket.on('offline-mode', (data) => {
         const { setOnlineUsersAction, setIsOfflineModeAction } = this.props;
         let action = data?.is_offline_mode  ? 'pop' : 'push';
         setIsOfflineModeAction(data.is_offline_mode)
         const user = data?.user;
         if(user){
            setOnlineUsersAction(user, action);
         }
      });

   }

   _initConnection = () => {
      const { siteInfo: { subdomain } } = this.props;
      this.socket = initChatSocket(subdomain)
   }

   setSocketConnected  = bool => {
      const { setSocketConnectedAction, isSocketConnected } = this.props
      if(isSocketConnected !== bool) {
         setSocketConnectedAction(bool)
      }
   }

   onClickChat = (item = {}, bool, withoutAnimated = false) => {
      const { onClickChat, setChatPanel, chatPanel, screenWidth, activeMessageTab } = this.props
      this.loaderText = !item.user_uuid ? 'Loading group chat' : 'Loading private chat'

      onClickChat(bool)
      if(!chatPanel.isOpen !== bool){
         let chatPanelData = {
            isMobile: screenWidth < 1025,
            isOpen: !bool,
         }
         if(!bool) {
            chatPanelData = {
               ...chatPanelData,
               closeChatMessages: true,
            }
         }
         if(withoutAnimated) {
            chatPanelData = {
               ...chatPanelData,
               animationClass: {
                  transform: 'translateX(0)',
                  WebkitTransform: 'translateX(0)',
               },
            }
         }
         setChatPanel(chatPanelData)

      }
      if(!!bool) {
         this.onHiddeChatMessages()
      }
      this.conversationScrollPosition(activeMessageTab.chat_room_id)
      this.onFetchMessages(item.chat_room_id, item)
      if(screenWidth < 1024 && +QueryParams.getParam('conversation') !== item.chat_room_id){
         if(!+QueryParams.getParam('conversation')){
            QueryParams.pushQueryParam('conversation', item.chat_room_id)
         } else {
            QueryParams.addQueryParam('conversation', item.chat_room_id)
         }
      }

      if(!!item?.chat_room_id) {
         this.onRead(item)
      }

   }
   onFetchMessages = (id, item) => {
      const {
         publicMessages,
         privateMessages,
         fetchMessages,
         screenWidth,
      } = this.props
      let inted = false
      if(!item.user_uuid){
         inted = publicMessages.inited
      } else {
         inted = privateMessages.inited
      }
      fetchMessages(id, item, inted, () => {
         ChatHepler.syncDialogueScroll(null, id, this.scrollPositions[id])
         if(screenWidth > 1024) {
            ChatHepler.inputState()
         } else {
            const { chat_room_id, unread_messages_count } = item
            const chatInfo = {
               chat_room_id,
               unread_messages_count,
            }
            if(unread_messages_count && unread_messages_count > 0 && chat_room_id){
               this.onRead(chatInfo)
            }
         }
      })
   }


   handleReadConverstionId = id => {
      const { updateConverstionData } =  this.props
      updateConverstionData(id, { unread_messages_count: 0 })

   }

   handleSeenConverstionId = (data) => {
      const { updateConverstionData } =  this.props
      const {
         conversationId,
         unread_messages_count_of_second_participant,
         last_seen_of_second_participant,
      } = data
      updateConverstionData(conversationId, { unread_messages_count_of_second_participant, last_seen_of_second_participant })

   }
   onRead = item => {
      if(!this.socket) {
         return
      }
      if(item && item.unread_messages_count > 0){
         clickedInChat()
         let data = {
            conversationId: item.chat_room_id,
         }
         this.socket.emit('conversation:read', data)
         this.handleReadConverstionId(item.chat_room_id)
         const { authUser } = this.props
         if(item && item.last_message.user_uuid !== authUser.uuid) {
            this.socket.emit('message:seen', { ...data, lastSeenTime: DateFormatter.convertToUtc(Date.now()) })
         }
      }
   }

   // start like message
   handleLikeMessage = data => {
      const { setMessagLike, authUser } = this.props
      let type = this.getConverstionType(data.conversationId)
      let messageData = {
         id: data.messageId,
         isMyLiked: authUser.uuid === data.user.uuid,
         isLiked: data.isLiked,
         type,
      }
      setMessagLike(messageData)
   }
   onLikeMessage = data => {
      const { authUser } = this.props
      const newData = this.setSoketEmitData(data)
      this.socket.emit('message:like', newData)
      this.handleLikeMessage({ ...newData, user: authUser })
   }
   // end like message

   // start delete message
   handleDeleteMessage = data => {
      const { deleteMessage } = this.props
      const { conversationId, messageId } = data
      let type = this.getConverstionType(conversationId)

      let messageData = {
         id: messageId,
         type,
         lastMessage: data?.lastMessage,
      }
      deleteMessage(messageData)
   }

   onDeleteMessage = data => {
      const newData = this.setSoketEmitData(data)
      this.socket.emit('message:delete', newData)
      this.handleDeleteMessage(newData)
      toast.remove('Message has been unsent')

   }
   // end delete message

   // start user typeing
   handleTyping = (id, user, type, action = 'type', typingType) => {
      const { groupChat, setTyper, privateChat } =  this.props
      let activeChat = {}
      const userUuid = user.uuid
      let timeout = {}
      switch (type) {
         case 'public':
            activeChat = groupChat
            timeout = this.publicThreadTypersRemovers;

            break;

         case 'private':
            activeChat = privateChat
            timeout = this.privateThreadTypersRemovers;
            break;
         default:
            break;
      }
      if(activeChat && activeChat.chat_room_id === id) {
         if('stop' === action){
            clearTimeout(timeout[userUuid]);
            this.stopTyping(type, userUuid)
            return
         }
         const typers = { ...activeChat.typers }
         const userTyper = typers[userUuid]
         if(!userTyper) {
            typers[userUuid] = user;
            let data = { groupChat: {
               ...groupChat,
               typers,
               typingType,
            } }
            if('private' === type) {
               data = {
                  privateChat: {
                     ...privateChat,
                     typers,
                     typingType,
                  },
               }
            }
            setTyper(data)
         }
         const timeoutId = timeout[userUuid];
         if(timeoutId) {
            clearTimeout(timeoutId);
         }
         timeout[userUuid] = setTimeout(() => {
            this.stopTyping(type, userUuid)
         }, 5000);
      } else {

      }
   }
   userTyping = (typingType = 'text') => {
      const {
         mutedInfo,
         activeMessageTab: {
            id: conversationId,
         } } =  this.props
      let data = {
         conversationId,
      }
      const newData = this.setSoketEmitData(data)
      if(mutedInfo.isMuted) {
         return
      }
      this.socket.emit('typing', { ...newData, typingType })
   }

   stopTyping = (type, userUuid) => {
      let typers = {}
      const { groupChat, setTyper, privateChat } =  this.props
      switch (type) {
         case 'public':
            typers = { ...groupChat.typers }
            delete typers[userUuid]
            setTyper({ groupChat: {
               ...groupChat,
               typers,
            } })
            delete this.publicThreadTypersRemovers[userUuid];

            break;

         case 'private':
            typers = { ...privateChat.typers }
            delete typers[userUuid]
            setTyper({ privateChat: {
               ...privateChat,
               typers,
            } })
            delete this.privateThreadTypersRemovers[userUuid];
            break;
         default:
            break;
      }
   }

   // end user typeing

   // start online user
   setOnlineMembers = (data, action, fetch = false) => {

      const { setOnlineUsersAction, onlineUsers, isOfflineMode } = this.props
      if(isOfflineMode && 'push' === action && data.admin){
         return
      }
      let index = null
      if(action) {
         index = onlineUsers.findIndex(elm => elm.uuid === data.uuid)
      }
      const returnFunction = (index > -1 && 'push' === action) || (index < 0 && 'pop' === action)
      if(returnFunction) {
         return
      }
      let newData = data;
      if(isOfflineMode && !action){
         newData = data.filter(el => !el.admin);
      }
      setOnlineUsersAction(newData, action, fetch);
   }

   onCloseModal = (notoutside, withoutAnimated = false) => {
      // this.initChatSettings(true)
      const { onClickChat, setChatPanel, chatPanel, screenWidth } = this.props
      if(screenWidth < 1024 && !!QueryParams.getParam('conversation')){
         history.goBack()
      }
      onClickChat(false)
      if(notoutside) {
         let chatpanelData = {
            isMobile: screenWidth < 1025,
            isOpen: !chatPanel.isOpen,
         }
         if(withoutAnimated) {
            chatpanelData = {
               ...chatpanelData,
               animationClass: {},
               closeChatMessages: !chatPanel.isOpen,
            }
         }
         if(!chatPanel.isOpen){
            chatpanelData = {
               ...chatpanelData,
               closeChatMessages: !chatPanel.isOpen,
            }
         }
         setChatPanel({ ...chatpanelData })
         if(!!chatPanel.isOpen && !withoutAnimated) {
            this.onHiddeChatMessages(!chatPanel.isOpen)
         }
         if(screenWidth > 1024) {
            ChatHepler.inputState(false)
         }
      }

   }

   openShowOnlineMembers = (bool) => {
      this.setState({
         openOnlineMebersModal: bool,
      })
   }
   onHiddeChatMessages = () => {
      const { setChatPanel } = this.props
      this.Timeout = setTimeout(() => {
         setChatPanel({ closeChatMessages: false, animationClass: {} })
      }, 600)
   }
   // end online user

   // start message pagination
   messagesScroll = (e) => {
      const { scrollTop, scrollHeight, firstElementChild } = e.target
      var currentY = scrollTop;
      if(currentY - 10 < scrollHeight - this.previousY && currentY === 0) {
         this.nextPage(async () => {
            const top = firstElementChild.clientHeight - this.previousY
            e.target.scrollTo(0, top);
         })
      }
      this.previousY = firstElementChild.clientHeight;
   }

   nextPage =  async (callback) => {
      const {
         fetchNextMessages,
         isNextFetchingMessage,
         activeMessageTab: { type, id },
      } = this.props;
      const { current_page: currentPage, last_page: pages } = this.props[`${ type }Messages`]
      if(currentPage < pages && !isNextFetchingMessage) {
         await fetchNextMessages(id, currentPage + 1);
         if(callback) {
            callback()
            return
         }
         return
      } else {
         return
      }
   }
   // end message pagination

   // start users pagination
   handleScrollMembers = (e, id) => {
      const { scrollHeight, clientHeight, scrollTop } = e.target
      if(((scrollHeight - scrollTop) - clientHeight < 10)) {
         this.nextPageMembers(id)
      }
   }
   nextPageMembers =  (id) => {
      const {
         fetchMessageLikedMembers,
         likedMemberByMessage,
         likedMemberByMessage: { current_page: currentPage, last_page: pages },
      } = this.props;
      let query = [];
      if(currentPage < pages && !likedMemberByMessage.fetchingScroll) {
         this.filterMember = { ...this.filterMember, page: currentPage + 1 };
         query = this.generateQuery();

         fetchMessageLikedMembers(query, currentPage + 1);
      } else {
         return
      }
   }
   // end users pagination

   // start send and update message

   onSendMessage = (text, parent, updateMessageId, callback, message) => {
      if(updateMessageId) {
         this.updateThisMessage(updateMessageId, { text, updateMessageType: message?.updateMessageType }, callback)
      } else {
         this.sendNewMessage(text, parent, callback)
      }

   }

   sendNewMessage = async (message, parent, callBack) => {
      let randomid = Math.random() * (700 - 2000) + 2000;
      const { authUser } = this.props
      const {
         activeMessageTab: {
            type,
         },
         privateChat,
         openClosedConversation,
      } = this.props
      let conversationId = this.props.activeMessageTab.id
      if(!conversationId) {
         try {
            const { updatePrivateConversation } =  this.props
            const { data } = await createPrivateMessage({ uuid: authUser.uuid })
            conversationId = data.chat_room_id
            updatePrivateConversation(data.chat_room_id)
         } catch (error) {

         }
      }
      if(privateChat && 'closed' === privateChat.type && conversationId === privateChat.chat_room_id) {
         openClosedConversation(conversationId)
      }
      const parentMessageId = parent ? parent.parentMessageId : null
      const parentMessageUnlockDetails = parent ? parent.parentMessageUnlockDetails : null

      const  parentUnsendDate = parent?.parentUnsendDate
      const  parentShowDurationCountdownToMember = parent?.parentShowDurationCountdownToMember
      const  parentDurationInMinutes = parent?.parentDurationInMinutes

      var sentAt = DateFormatter.getCurentTimeMilliseconds()
      let messageInfo = {};
      let messageInfoForRedux = {};
      if('string' === typeof message){
         messageInfo = {
            text: message,
         }
         messageInfoForRedux = {
            text: message,
         }
      }
      if('object' === typeof message){
         let path = message?.fullSrc;
         if('fullSrc' in message){
            delete message.fullSrc
         }
         messageInfo = {
            ...message,
         }
         messageInfoForRedux = {
            ...message,
         }
         switch (message?.type) {
            case 'voice_message':
               messageInfoForRedux = {
                  ...messageInfoForRedux,
                  unlock_details: {
                     unlock_price: 0,
                     src: path,
                     audio_duration: message.duration,
                  },
               }
               break;
            case 'photo_unlock':
               const { data } = await getObjectUrl([messageInfoForRedux.resources[0]], 'images/thumb-');
               path = data[messageInfoForRedux.resources[0]]
               messageInfoForRedux = {
                  ...messageInfoForRedux,
                  unlock_details: {
                     unlock_price: 0,
                     cover: path,
                     cover_thumb: path,
                     photos_count: messageInfoForRedux.resources?.length,
                  },
               }
               break;

            default:
               break;
         }
      }
      let data = {
         ...messageInfo,
         parentMessageId,
         sentAt,
         conversationId,
         unlockPrice: 0,
         parentMessageUnlockDetails,
         parentUnsendDate,
         parentShowDurationCountdownToMember,
         parentDurationInMinutes,
      }
      let newData = { ...data, conversationId: conversationId }
      let newMessage = {
         sent_at: sentAt,
         id: randomid,
         is_liked_by_user: false,
         likes_count_from_other_users: 0,
         parent: parentMessageId ? parent : null,
         ...messageInfoForRedux,
         user: authUser,
         isDraft: true,
      }

      this.darftNewMessage = newMessage

      this.handleSocketEmitSend(newData, type, randomid, false, (data) => {
         this.handleAddNewMessage({ ...newMessage, ...data }, type, true)
      })

      if(callBack) {
         callBack()
      }
   }

   handleSocketEmitSend = (newData, type, randomid, bool, callBack) => {
      const { deleteMessage, price, authUser } = this.props
      this.socket.emit('message:send', { ...newData, sendMessagePrice: bool ? price : 0 }, data => {
         let messageData = {}
         let info = {}
         let callBackData = data.data || {}
         if(data.error) {
            const { setChatSettings, updateConverstionData } = this.props
            let notActiveSettings = {}
            let conv = { last_message: {}, members_count: null, unread_messages_count: null }
            switch (data.error) {
               case 'cannot_send_message':
               case 'cannot_send_voice_message':
               case 'voice_message_limit_reached':
               case 'cannot_send_photo_message':
                  if('public' === type) {

                  } else {
                     if('cannot_send_voice_message' === data.error){
                        notActiveSettings = { private_voice_message_is_active: false }
                        toast.error('Voice messaging is currently disabled.')
                     } else if('voice_message_limit_reached' === data.error){
                        const { max_voice_message_duration_limit } = callBackData;
                        notActiveSettings = { private_max_voice_message_duration_limit: max_voice_message_duration_limit }
                        toast.error(`${ max_voice_message_duration_limit } seconds voice note time limit has been reached`)
                     } else if('cannot_send_photo_message' === data.error){
                        notActiveSettings = { private_photo_message_is_active: false }
                        toast.error('Attach image is currently disabled.')
                     } else {
                        notActiveSettings = { is_private_chat_active: false }
                     }
                     conv.user_uuid = null
                  }
                  deleteMessage({
                     id: randomid,
                     type,
                  })
                  updateConverstionData(newData.conversationId, { ...conv })
                  setChatSettings(notActiveSettings)
                  break;
               case 'conversation_is_not_active':
                  if('public' === type) {
                     notActiveSettings = { is_group_chat_active: false }

                  } else {
                     notActiveSettings = { chat_private_is_active: false }
                     conv.user_uuid = null
                  }
                  deleteMessage({
                     id: randomid,
                     type,
                  })
                  updateConverstionData(newData.conversationId, { ...conv })
                  setChatSettings(notActiveSettings)
                  break;
               case 'messaging_is_muted':
                  const { setMutedMemberInfo } = this.props

                  messageData = {
                     id: randomid,
                     type,
                  }
                  deleteMessage(messageData)
                  info = {
                     muted_period_in_seconds: callBackData.mute_period_in_seconds,
                     muted_since: callBackData.muted_since,
                  }
                  setMutedMemberInfo({ ...info, isMuted: true, isMutedModal: true })

                  break;
               case 'payment_required':
                  const { wallet_balance, price_for_text_message } = callBackData;
                  let modalType = '';
                  switch (newData.type) {
                     case 'voice_message':
                        modalType = 'chat_voice_message';
                        this.payPerMessage = { resources: newData.resources, duration: newData.duration };

                        break;
                     case 'photo_unlock':
                        modalType = 'chat_photo_message';
                        this.payPerMessage = { resources: newData.resources };
                        if(newData.text){
                           this.payPerMessage = {
                              ...this.payPerMessage,
                              text: newData.text,
                           }
                        }
                        break;

                     default:
                        modalType = 'chat_text_message';
                        this.payPerMessage = { text: newData.text };
                        break;
                  }
                  this.modalType = modalType;
                  const { setSendModalState, paymentSend, updateWalletBalanc, fetchPurchaseMethods } = this.props

                  if(price_for_text_message > 4){
                     this.draftMessage = { newData, type, randomid }
                     const input = document.querySelector('.editable-input')
                     if(input) {
                        input.blur()
                     }
                     this.chatPeyParUsingOnlyWallet = false;
                     this.payPerMessage = { ...this.payPerMessage, parentMessageId: newData?.parentMessageId || null };
                     setSendModalState({
                        isOpenSendModal: true,
                        isOpenChoosePaymentModal: true,
                        isFetchingModal: true,
                        paymentButtonLoading: true,
                        modalKey: 'chat',
                        modalType: modalType,
                        isSend: false,
                        price: price_for_text_message,
                     })
                     fetchPurchaseMethods(modalType, null, newData.type, false)
                     return
                  }
                  messageData = {
                     id: randomid,
                     type,
                     unlockPrice: price_for_text_message,
                  };

                  const autoPay = this.isWalletAutoPay()
                  this.draftMessage = { newData: { ...newData, user: authUser, ...this.darftNewMessage  }, type, randomid }

                  updateWalletBalanc({ wallet_balance })

                  if(wallet_balance < price_for_text_message) {
                     this.setState({
                        walletModalAnimate: 'up',
                     })
                     const payedModal = {
                        isOpenSendModal: true,
                        modalType: modalType,
                        isSend: false,
                        isFetching: false,
                        isNotEnoughtBalance: true,
                        modalKey: 'chat',
                        price: price_for_text_message,
                     }
                     this.chatPeyParUsingOnlyWallet = true;

                     setSendModalState(payedModal)
                     const input = document.querySelector('.editable-input')
                     if(input) {
                        input.blur()
                     }
                     const messageData = {
                        key: 'isDraft',
                        type,
                     }
                     deleteMessage(messageData)
                  } else {
                     if(!autoPay) {
                        this.setState({
                           walletModalAnimate: 'up',
                        })
                        const { price_for_text_message } = callBackData
                        const payedModal = {
                           isOpenSendModal: true,
                           modalType: modalType,
                           isSend: false,
                           isFetching: false,
                           isNotEnoughtBalance: false,
                           modalKey: 'chat',
                           price: price_for_text_message,
                        }
                        this.chatPeyParUsingOnlyWallet = true;

                        setSendModalState(payedModal)
                        const input = document.querySelector('.editable-input')
                        if(input) {
                           input.blur()
                        }
                     } else {
                        const { deleteMessage } = this.props
                        this.setState({
                           walletModalAnimate: 'up',
                        })
                        paymentSend(
                           { type: modalType },
                           () => {
                              this.handleSocketEmitSend(newData, type, randomid, true, (data) => {
                                 this.handleAddNewMessage({ ...this.darftNewMessage, ...newData, ...data, user: authUser }, type, true)
                              })
                           },
                           {
                              isOpenSendModal: false,
                              isSend: false,
                              modalKey: 'chat',
                              modalType: modalType,
                              price: callBackData.price_for_text_message,
                           },
                           () => {
                              const messageData = {
                                 key: 'isDraft',
                                 type,
                              }
                              deleteMessage(messageData)
                           }
                        )
                     }
                  }
                  break;
               case 'incorrect_payload':
                  break;

               case 'internal_server_error':
                  break;

               case 'access_denied':
                  break;
               case 'message_is_too_long':
                  messageData = {
                     error_message: "Message too long",
                  }
                  break;
               default:
                  break;
            }
         } else {
            const { messageId, parentMessage } = callBackData
            messageData = {
               id: messageId,
               parent: parentMessage,
               isDraft: false,
               unlockPrice: bool ? price : 0,
            }
            this.draftMessage = {};
            this.payPerMessage = {};
            if(callBack) callBack(messageData)
            // this.handleUpdateThisMessage(randomid, { ...messageData }, type);
         }
      })
   }

   handleAddNewMessage = (message, type, isMyMessage) => {
      const { addNewMessage } = this.props
      addNewMessage({ message, type, isMyMessage })
   }

   updateThisMessage = async (messageId, message, callback) => {
      const { activeMessageTab: {
         type,
      } } =  this.props

      const newData = this.setSoketEmitData({ messageId, ...message })
      this.socket.emit('message:update', newData, data => {
         if(data.error) {
            this.handleUpdateThisMessage(messageId, { error_message: "Message too long" }, type)
         }
      })
      if((message.text || message?.updateMessageType !== 'text_message') && message.text.length < 20001) {
         this.handleUpdateThisMessage(messageId, { ...message, edited: true }, type)
      }
      if(message.type && message.type.includes('_unlock')) {
         this.handleUpdateThisMessage(messageId, newData, type)
      } else if(callback && message.text.length < 20001) {
         callback()
      }
   }

   handleUpdateThisMessage = (id, data, type) => {
      const { updateMessageData } = this.props
      updateMessageData({ id, data, type  })
   }

   fetchChat = (start = true) => {
      const { init, inited, authUser } = this.props
      if(!inited) {
         init()
      }
      this.chatDropDownState = true
      const subscriber = authUser ? authUser.subscriber : ''
      this.initChatSettings(!start)
      if('public' === getUserStatusType(subscriber)) {
         const { groupChat, privateMessages } = this.props
         const item = groupChat
         const inted = privateMessages.inited
         if(item) {
            return
         }
         if(item.chat_room_id) {
            this.onFetchMessages(item.chat_room_id, item, inted)
         }
      }
   }

   // closeChat = () => {
   //    if(!this.props.chatPanel.isOpen) {
   //       this.initChatSettings(true)
   //    }
   // }
   conversationScrollPosition = id => {
      if(!id) {
         return
      }
      const dialogue = document.querySelector(`#messages-content-${ id }`)
      this.scrollPositions[id] = dialogue ? dialogue.scrollTop : null
   }

   async initChatSettings(stop){
      const { authUser } = this.props
      if(!authUser || !Auth.isTokenExists()) {
         return
      }
      const { setChatSettings, chatPanel } = this.props;
      // let hiddeChat = hiddeChatIcon
      if(!stop) {
         let res = {};
         res = await chatInit();
         const { data: { chat_settings, data: { private_chat, group_chat } } } = res;
         let item = null;
         if(chatPanel.isOpen) {
            if(chat_settings.chat_private_is_active && !chat_settings.is_group_chat_active) item = private_chat
            if(!chat_settings.chat_private_is_active && chat_settings.is_group_chat_active) item = group_chat
         }
         if(item) {
            const { screenWidth } = this.props
            this.loaderText = !item.user_uuid ? 'Loading group chat' : 'Loading private chat'
            this.conversationScrollPosition(item.chat_room_id)
            this.onFetchMessages(item.chat_room_id, item)
            if(screenWidth < 1024 && +QueryParams.getParam('conversation') !== item.chat_room_id){
               if(!+QueryParams.getParam('conversation')){
                  QueryParams.pushQueryParam('conversation', item.chat_room_id)
               } else {
                  QueryParams.addQueryParam('conversation', item.chat_room_id)
               }
            }
         }
         setChatSettings(chat_settings)
         // hiddeChat = chat_settings.chat_private_is_active || chat_settings.is_group_chat_active
      }
      // const oldhiddeChatIcon = !settings.chat_private_is_active && !settings.is_group_chat_active
      // let stopState = oldhiddeChatIcon ? hiddeChat : stop
      // await new Promise((resolve, rej) => {
      //    if(stopState) {
      //       window.clearTimeout(this.longPolingTime)
      //       this.longPolingTime = 0
      //    } else {
      //       this.longPolingTime = setTimeout(() => resolve(), 30000)
      //    }
      // });
      // await this.initChatSettings(stopState);

   }


   tipAction = (bool = true) => {
      const { getWalletBalance, setSendModalState, setTipModalState, isCheckLimitFetching } = this.props;
      if(!isCheckLimitFetching) {
         if(bool){
            getWalletBalance();
            setSendModalState({ modalKey: 'tip', modalType: 'tip' });
            setTipModalState({ isTipModal: true, isInitTip: true, isLimitModal: false })
         } else {
            setTipModalState({ isTipModal: false });
         }
      }
   }

   // end send and update message


   goToWalletTopUp = (type) => {
      const { initWalllet, getWalletBalance } = this.props
      getWalletBalance();
      const payedModal = {
         modalType: 'top_up',
         isNotEnoughtBalance: false,
         modalKey: 'chat',
      }
      initWalllet(payedModal)
   }

   onSelectAmount = amount => {
      this.setState({
         selectedAmount: amount,
      })
   }

   topUpMyWallet = async (id) => {
      const {
         authUser,
         goTo,
         checkWalletLimitStart,
         checkWalletLimitCompleted,
         checkWalletLimitFailed,
      } = this.props
      const { isAddProcessingFees } = this.state;
      this.setState({ animateLimit: 'up' });
      checkWalletLimitStart();
      try {
         const data = await checkWalletLimit();
         checkWalletLimitCompleted(data);
         this.onCloseModal(true, true)
         this.closeWalletPayModal()
         if(!authUser){
            goTo(Router.route('SIGN_IN').getCompiledPath(), `goTo=wallet_${ id }`)
         } else {
            goTo(Router.route('PURCHASE_WALLET').getCompiledPath({ id: id.id }), `add_processing_fees_to_my_top_up_amount=${ isAddProcessingFees }`)
         }
      } catch (error) {
         if(error && error.response) {
            checkWalletLimitFailed(error.response)
         }
      }
   }


   closeWalletPayModal = () => {

      this.setState({
         walletModalAnimate: 'down',
      })
      const { screenWidth } = this.props
      const { setSendModalState } = this.props
      if(screenWidth < 701){
         setTimeout(() => {
            closModal(setSendModalState)
         }, 800)
      } else {
         closModal(setSendModalState)
      }
      const { type, randomid } = this.draftMessage
      if(randomid) {
         const {  deleteMessage } = this.props
         const messageData = {
            key: 'isDraft',
            type,
         }
         deleteMessage(messageData)
      }
      const input = document.querySelector('.editable-input')
      if(input) {
         input.focus()
      }
      function closModal(setSendModalState){
         const payedModal = {
            isFetching: false,
            isOpenSendModal: false,
            isNotEnoughtBalance: false,
            isSend: false,
            modalType: null,
            modalKey: null,
            price: null,
         }
         setSendModalState(payedModal)

      }
   }

   isWalletAutoPay = () => {
      const { authUser } = this.props
      const walletAutoShowData = JSON.parse(localStorage.getItem('dont_show_chat_text_pay_modal_24_hours')) || {}
      let result = false
      let authUserWalletModal = walletAutoShowData[authUser.uuid]
      if(authUserWalletModal && !!Number(authUserWalletModal.value)) {
         const now = new Date()
         if(now.getTime() > authUserWalletModal.expiry) {
            let newState = delete walletAutoShowData[authUser]
            if(!isEmptyObject(newState)) {
               localStorage.setItem('dont_show_chat_text_pay_modal_24_hours', newState)
            } else {
               localStorage.removeItem('dont_show_chat_text_pay_modal_24_hours')
            }
         }
         result = !!Number(authUserWalletModal.value)
      }
      return result
   }

   onChangeAddProcessingFees = (name, value) => {
      this.setState({ isAddProcessingFees: value })
   }

   onWalletModalClose = () => {
      const { setWalletLimitState, screenWidth } = this.props;
      this.setState({ animateLimit: 'down' });
      if(screenWidth < 701) {
         this.timerFetching = setTimeout(() => {
            setWalletLimitState({ isLimitModal: false })
         }, 800)
      } else {
         setWalletLimitState({ isLimitModal: false })
      }
   }


   onStream = async (message, mainMessageId) => {
      const {
         fetchPurchaseMethods,
      } = this.props
      let routeName = 'messages';
      let id = message.id;
      const singleMessageType = ['photo_unlock', 'video_unlock', 'voice_unlock']
      if('private_mass_message' === message.type || 'mass_message' === message.type || 'live_stream' === message.type || 'multiple_attachment' === message.type){
         this.promoMessage = null;
         if(message.unlock_details && message.unlock_details.unlock_price === 0) {
            return
         } else {
            this.streamPrice = message.unlock_details.unlock_price;
            this.messageType = message.type;
            this.messageId = message.id;
            if('live_stream' === message.type) {
               routeName = 'livestream';
               this.messageType = 'livestream';
               this.messageId = message.unlock_details.id
               id = message.unlock_details.id
            }
            this.messageUnlockType = message.unlock_details.type;

            if('multiple_attachment' === message.type) {
               this.messageUnlockType = message.type;
            }
            if('multiple_attachment' === message.unlock_details.type && ('private_mass_message' === message.type || 'mass_message' === message.type)) {
               this.messageUnlockType = message.unlock_details.type;
            }
         }
      } else if(singleMessageType.includes(message.type)) {
         this.promoMessage = null
         if(message.unlock_details && message.unlock_details.unlock_price === 0) {
            return
         } else {
            this.streamPrice = message.unlock_details.unlock_price;
            this.messageType = message.type;
            this.messageId = message.id;
         }
      } else {
         this.promoMessage = message
         this.streamPrice = message.promo_resource.stream_price;
         this.messageId = message.promo_resource.id;
         if(message.type === 'promo_video'){
            this.messageType = 'video';
         }
         if(message.type === 'promo_photoset'){
            this.messageType = 'photoset';
         }
         routeName = this.messageType

      }

      const onlyWalletPay = this.streamPrice < 4
      fetchPurchaseMethods(routeName, id, this.messageType, onlyWalletPay, mainMessageId)

   }

   onCloseSendModal = (bool) => {
      const { setSendModalState, setTipModalState } = this.props;
      setTipModalState({ 'isTipModal': false });
      setSendModalState({ isOpenSendModal: bool, isSend: false, isNotEnoughtBalance: false, modalKey: 'tip' })
      if(!!QueryParams.getParam('conversation')) {
         QueryParams.removeQueryParam('openChoosePurchase')
      }
   }

   closeChatWhitRedirect = () => {
      const {
         setChatPanel,
         screenWidth,
      } = this.props
      this.isRedirect = true
      setChatPanel({
         isMobile: screenWidth < 1025,
         animationClass: {
            transform: 'translateX(100%)',
            WebkitTransform: 'translateX(100%)',
         },
         isOpen: false,
      })
   }
   updateMassMessageAfterPayment = () => {
      let promoResource = {
         ...this.promoMessage.promo_resource,
         stream_state: 'free',
         stream_status: null,
         stream_price: 0,
      }

      this.handleUpdateThisMessage(this.promoMessage.id, { promo_resource: promoResource }, 'private')
      this.promoMessage = null
   }
   onSaveUploadPhotos = (data, action) => {
      const {
         updateConverstionData,
         privateChat,
      } = this.props
      if(action === 'update') {
         updateConverstionData(privateChat.chat_room_id, {
            ...privateChat,
            content: {
               ...privateChat.content || {},
               ...data,
            },
         })

      } else {
         updateConverstionData(privateChat.chat_room_id, {
            ...privateChat,
            content: data,
         })
      }
      let ollContents = window.currentConversationContent ? JSON.parse(window.currentConversationContent) : {}
      if('add' === action) {
         ollContents = {
            ...ollContents,
            [privateChat.chat_room_id]: data,
         }
      }
      if('remove' === action) {
         delete ollContents[privateChat.chat_room_id]
      }
      if('update' === action) {
         ollContents[privateChat.chat_room_id] = { ...ollContents[privateChat.chat_room_id], ...data }
      }
      window.currentConversationContent = JSON.stringify(ollContents)
   }
   onSendVoiceMessage = async (file, details, callback) => {
      const basename = randomstring.generate(32);
      const ext = 'mp3';
      const filename = `audio-${ basename }.${ ext }`;
      const formData = new FormData();
      formData.append('filename', filename);
      formData.append('acl', 'private');
      formData.append('success_action_status', '201');
      formData.append('file', file);

      try {
         const { data } = await uploadAudioRecord(formData);
         if(callback){
            callback()
            const  blobUrl = URL.createObjectURL(file);
            const messageData = {
               unlockPrice: 0,
               lockedPosterIsBlur: null,
               resources: [data?.path],
               type: 'voice_message',
               resourceId: null,
               text: '',
               duration: details.duration,
               fullSrc: blobUrl,
            }
            this.sendNewMessage(messageData, details?.replyMessage, null, () => {
               if(callback){
                  callback()
               }
            })

         }
      } catch (error) {

      }
   }

   onUpdateRecordStatus = (status) => {
      if(status){
         QueryParams.setQueryParam('recorded_voice', status)
      } else if(QueryParams.getParam('recorded_voice')){
         QueryParams.removeQueryParam('recorded_voice');
      }
      window.chatVoiceMessageRecorded = status;
   }

   onClickNotificationMessagePrimaryButton = (args = {}) => {
      const { type, promoResource } = args

      switch (true) {
         case ['promo_poll', 'promo_poll_24_hour_left', 'promo_poll_ended'].includes(type):
            const { openPollModal, openClosePollConfirmDialog, closePollModal } = this.props

            if("unpublished" === promoResource.status) {
               openClosePollConfirmDialog('unpublished_poll')
            } else {
               openPollModal((pollData) => {
                  if(pollData?.id !== promoResource?.id) {
                     closePollModal()

                     setTimeout(() => {
                        openClosePollConfirmDialog('unpublished_poll')
                     })
                  }
               })
            }
            break;

         default:
            break;
      }

   }

   render() {

      const {
         screenWidth,
         authUser,
         isFetchingInit,
         isFetchingMessage,
         isNextFetchingMessage,
         likedMemberByMessage,
         fetchMessageLikedMembers,
         goTo,
         siteInfo,
         onlineUsers,
         isSocketConnected,
         privateChat,
         groupChat,
         settings,
         groupChatTypersMessage,

         privateMessages,
         publicMessages,
         activeMessageTab,
         showNavigationList,
         privateChatTypersMessage,
         mutedInfo,
         chatPanel,
         setMutedMemberInfo,
         tipModalData,
         paymentSend,
         purchaseModalType,
         isOpenPurchaseModal,
         isNotEnoughtBalance,
         isFetchingWalletPayed,
         amountData,
         isFetchingWalletAmount,
         modalKey,
         price,
         walletBalance,
         deleteMessage,
         walletLimitModalData,
         // setChatPanel,

         onlineStream,
         hiddeChatIcon,
         paymentButtonLoading,
         locationPath,
         isFetchingLiveStreamMessages,
         streamConversation,
         currentLiveStream,
         showOnlyViews,
         downloadFile,
         paymentButtonResourceId,
         mainMessageId,
         initLivestreamData,
      } = this.props;
      const currentLIveStreamSession = onlineStream && !!Router.route('LIVE_STREAM_STUDIO').match(locationPath)
      if(hiddeChatIcon && !currentLIveStreamSession) return null
      let list = []
      if(!isFetchingInit) {
         list = []
         if(currentLIveStreamSession) {
            list = [
               ...list,
               {
                  ...streamConversation,
                  type: 'livestream',
                  conversation_is_not_active: false,
                  // conversation_is_not_active: !currentLiveStream.live_stream_chat_is_active, chat_access_type
               },
               // { ...groupChat, isGroup: true, user_is_typing: !!groupChatTypersMessage, conversation_is_not_active: !settings.is_group_chat_active, type: 'public' },
            ]
         }
         if(settings.chat_private_is_active) {
            list = [
               ...list,
               { ...privateChat, user_is_typing: !!privateChatTypersMessage, conversation_is_not_active: !settings.is_private_chat_active, type: 'private'  },
            ]
         }
         if(settings.is_group_chat_active) {
            list = [
               { ...groupChat, isGroup: true, user_is_typing: !!groupChatTypersMessage, conversation_is_not_active: !settings.is_group_chat_active, type: 'public' },
               ...list,
            ]
         }
      }
      const {
         openOnlineMebersModal,
         selectedAmount,
         walletModalAnimate,
         isAddProcessingFees,
         animateLimit,
         animateSend,
      } = this.state
      let data = {}
      let typerText = ''
      let emptyState = {}
      let chatInfo = {}
      let lastSeen = null
      let notActiveText = ''
      let notActive = false
      let isHaseAccess = true
      let needToJoin = false
      let fetching = isFetchingMessage
      const { type } = activeMessageTab
      const subscriber = authUser ? authUser.subscriber : ''
      let status =  getUserStatusType(subscriber)
      if(authUser) {
         switch (type) {
            case 'public':
               data = publicMessages
               chatInfo = groupChat
               typerText = groupChatTypersMessage
               emptyState = {
                  avatar: groupChat.avatars,
                  text: `Type your message to start chatting with ${ groupChat.members_count }
                   ${ groupChat.members_count === 1 ? "member" : "members" }...`,
               }
               if(!!settings.is_group_chat_active && groupChat.last_message.user_uuid === authUser.uuid){
                  lastSeen = groupChat.last_seen
               }
               notActiveText = 'Sorry, the group chat is no longer available.'
               notActive = !settings.is_group_chat_active
               isHaseAccess = 'active' === status && !groupChat.conversation_is_not_active
               break;
            case 'livestream':
               data = null
               chatInfo = streamConversation
               typerText = null
               lastSeen = null
               emptyState = {
                  // avatar: groupChat.avatars,
                  text: `Type your message to start...`,
               }
               notActiveText = 'Sorry, the live chat is no longer available.'
               notActive = !currentLiveStream.live_stream_chat_is_active
               isHaseAccess = 'blurred_cannot_message' !== currentLiveStream.chat_access_type
               fetching = isFetchingLiveStreamMessages
               break;
            case 'private':
               data = privateMessages
               chatInfo = privateChat
               typerText = privateChatTypersMessage
               emptyState = {
                  avatar: privateChat.user_avatar,
                  text: 'Type your message to start chatting...',
               }
               const {
                  unread_messages_count_of_second_participant,
                  last_seen_of_second_participant,
               } = privateChat
               if(!!settings.is_private_chat_active && privateChat.last_message.user_uuid === authUser.uuid && unread_messages_count_of_second_participant === 0 && last_seen_of_second_participant){
                  lastSeen = last_seen_of_second_participant
               }
               notActiveText = !settings.chat_private_is_active ? 'Sorry, the private chat is no longer available.' : null
               notActive = !settings.chat_private_is_active || !settings.is_private_chat_active
               needToJoin = !!settings.need_to_join
               isHaseAccess =  !privateChat.conversation_is_not_active
               break;
            default:
               break;
         }

      }

      const isMobile =  screenWidth < 1025
      let listView = null;
      let livestreamNeedToJoin = 'active' !== status;
      let planPrice = siteInfo.suggested_membership_plan_price;
      let livestreamChatAvailablePrices = currentLiveStream?.available_prices || [];
      if(currentLIveStreamSession && type === 'livestream' && !livestreamChatAvailablePrices.length){
         planPrice = null
         livestreamNeedToJoin = false;
      }
      listView = (
         <ChatList
            className=''
            onCloseChat={ this.onCloseModal }
            hasAccess={ !!authUser && isHaseAccess }
            converstions={ list }
            onClickConversation={ (id, item) => {
               this.loaderText = !item.user_uuid ? 'Loading group chat' : 'Loading private chat'
               this.conversationScrollPosition(chatInfo.chat_room_id)
               this.onFetchMessages(id, item)

               if(item?.chat_room_id && item?.unread_messages_count && item?.unread_messages_count > 0) {
                  this.onRead(item)
               }

               if(screenWidth < 1024 && +QueryParams.getParam('conversation') !== item.chat_room_id){
                  if(!+QueryParams.getParam('conversation')){
                     QueryParams.pushQueryParam('conversation', item.chat_room_id)
                  } else {
                     QueryParams.addQueryParam('conversation', item.chat_room_id)
                  }
               }
            } }
            onScroll={ this.messagesScroll }
            fetchNextMessages={ isNextFetchingMessage }
            isFetchingMessage={ fetching }
            authUser={ authUser }
            likesInfo={ likedMemberByMessage }
            onLikedMemberPagination={ this.handleScrollMembers }
            onFetchLikesInfo={ (id) => fetchMessageLikedMembers(id, null) }
            onClickLockedButton={ (isSignIn, showAvalablePricing = true) => {
               const { locationPath } = this.props;
               let path = ''
               let search = ''
               if(isMobile){
                  this.onCloseModal(true, true)
               }
               if(isSignIn) {
                  path = 'SIGN_IN'
               } else if(!authUser){
                  path = 'SIGN_UP'
                  search = 'goTo=join'
               } else {
                  path = 'JOIN'
                  if(showAvalablePricing){
                     search = '?chatId=1';
                     if(currentLIveStreamSession && type === 'livestream') {
                        const pageInfo = {
                           route_name: 'LIVE_STREAM_STUDIO',
                           page_name: 'livestream',
                           route_id: null,
                           goBack: 'livestream',
                        }

                        setReferrerUrl(pageInfo)
                        search = '?liveStreamId=chat'
                     }
                  }
               }
               if(!Router.route(path).match(locationPath)){
                  goTo(Router.route(path).getCompiledPath(), search)
               }
            } }
            planPrice={ planPrice }
            nonAccessAvatar={ siteInfo &&  siteInfo.admin_avatar }
            onUserTyping={ this.userTyping }
            onLikeMessage={ this.onLikeMessage }
            data={ data }
            activeMessageTab={ activeMessageTab }
            onDeleteMessag={ this.onDeleteMessage }
            onSendMessage={ this.onSendMessage }
            typerText={ typerText }
            mutedInfo={ mutedInfo }
            emptyState={ emptyState }
            onReadMessage={ (converstion) => {
               if(converstion){
                  if(!settings.is_private_chat_active) {
                     this.onRead(converstion)
                  }
               } else {
                  this.onRead(chatInfo)
               }
            } }
            isMobile={ isMobile }
            lastSeen={ lastSeen }
            messagesContentRef={ this.messagesContentRef }
            setMutedMemberInfo={ setMutedMemberInfo }
            notActiveText={ notActiveText }
            isNotActive={ notActive }
            needToJoin={ needToJoin }
            isSocketConnected={ isSocketConnected }
            loaderText={ this.loaderText }
            onClickTip={ this.tipAction }
            isOpen={ chatPanel.isOpen }
            closeChatPopup={ this.closeChatWhitRedirect }
            onStream={ this.onStream }
            goToContentMessage={ id => {
               goTo(Router.route('CHAT_UNLCOKED_CONTENT').getCompiledPath({ id }))
            } }
            goToJoin={ (id, notification) => {
               let params = '?chatId=1';
               if(currentLIveStreamSession && type === 'livestream') {
                  const pageInfo = {
                     route_name: 'LIVE_STREAM_STUDIO',
                     page_name: 'livestream',
                     route_id: null,
                     goBack: 'livestream',
                  }

                  setReferrerUrl(pageInfo)
                  params = '?liveStreamId=chat'
               }
               if(notification === 'promotion') {
                  params = ''
               }
               if(notification === 'photoset') {
                  params = `?photosetId=${ id }`
               }
               if(notification === 'video') {
                  params = `?videoId=${ id }`
               }
               goTo(Router.route('JOIN').getCompiledPath(), params)
            } }
            // onlineStream={ currentLIveStreamSession }
            paymentButtonLoading={ paymentButtonLoading }
            purchaseMessageId={ this.messageId }
            streamConversation={
               currentLIveStreamSession && type === 'livestream' ?
                  <LiveStreamConversation
                     planPrice={ planPrice }
                     memberCanOnlyRead={ 'can_read_and_cannot_message' === currentLiveStream.chat_access_type }
                     needToJoin={ livestreamNeedToJoin }
                     isMobile={ isMobile }
                  /> : null
            }
            openLiveStreamConversation={ () => {
               const { setActiveTab } = this.props;
               setActiveTab({
                  type: 'livestream',
                  id: 'live_stream',
                  conversation: {
                     conversation_name: 'Livestream chat',
                     avatars: null,
                  },
               })
            } }
            userStatus={ status }
            adminScreenName={ siteInfo.admin_screen_name }
            isNewVersion={ currentLIveStreamSession }
            isLiveStream={ currentLIveStreamSession }
            showOnlyViews={ showOnlyViews }
            downloadFile={ downloadFile }
            adminUuid={ privateChat.user_uuid }
            onSendVoiceMessage={ this.onSendVoiceMessage }
            onUpdateRecordStatus={ this.onUpdateRecordStatus }
            privateAttachmentSettings={ {
               voice_message_is_active: settings.private_voice_message_is_active,
               photo_message_is_active: settings.private_photo_message_is_active,
               private_max_voice_message_duration_limit: settings.private_max_voice_message_duration_limit,
            } }
            paymentButtonResourceId={ paymentButtonResourceId }
            onSaveUploadPhotos={ this.onSaveUploadPhotos }
            goTo={ goTo }
            mainMessageId={ mainMessageId }
            screenWidth={ screenWidth }
            onClickNotificationMessageButton={ this.onClickNotificationMessagePrimaryButton }
            currentLiveStream={ currentLiveStream }
            initLivestreamData={ initLivestreamData }
         />
      )
      if(showOnlyViews){
         return (
            <>
               {listView}
            </>
         )
      }
      return (
         <>
            {
               // ((isMobile && showNavigationList) || !isMobile) && !!authUser && (
               ((isMobile && showNavigationList) || !isMobile) && !!authUser  && !currentLIveStreamSession && (
                  <ChatNotification
                     isMobile={ isMobile }
                     onClickChat={ (...arg) =>  this.onClickChat(...arg, chatPanel.isOpen) }
                     onCloseModal={ this.onCloseModal }
                     showOnlineMembers={ () => this.openShowOnlineMembers(true) }
                     isFetchingInit={ isFetchingInit }
                     list={ list }
                     showOnlineMembersButton={ settings && settings.is_group_chat_active && settings.show_list_and_count_of_all_online_members }
                     isGroupTyper={ !!groupChatTypersMessage }
                     isPrivatetyper={ !!privateChatTypersMessage }
                     authUser={ authUser }
                     openChatDropDown={ () => {
                        this.fetchChat(true);
                     } }
                     closeChatDropDown={ this.closeChat }
                     isNotActive={ notActive }
                     onReadMessage={ (data) => {
                        if(!settings.is_private_chat_active) {
                           this.onRead(data)
                        }
                     } }
                     showNavigationList={ showNavigationList }
                     adminUuid={ privateChat.user_uuid }
                     siteInfo={ siteInfo }
                  />
               )
            }
            {
               ReactDOM.createPortal(
                  <div
                     style={ currentLIveStreamSession ? {
                        top: '58px',
                        ...chatPanel.animationClass,
                        boxShadow: 'none',
                     } : {
                        ...chatPanel.animationClass,
                        zIndex: !authUser ? '16' : '1',
                     } }
                     id='member_chat_modal'
                     className={ cx({
                        'fixed z-1 top-0 bottom-0 member-right-chat': true,
                        'shadow dark:shadow-dark': chatPanel?.isOpen,
                        'member-right-chat-w1': currentLIveStreamSession,
                     }) }
                  >
                     {
                        chatPanel.closeChatMessages && (
                           listView
                        )
                     }
                  </div>,
                  document.querySelector('body')
               )
            }
            {
               openOnlineMebersModal && (
                  <OnlineMembersLlst
                     headerText={ onlineUsers.length === 0 ? 'No members online' :  `${ onlineUsers.length } members online` }
                     isMobile={ screenWidth < 1025 }
                     chatLikesModalTogglehandler={ () => this.openShowOnlineMembers(false) }
                     members={ onlineUsers }
                     // onlineUsersfetching={  onlineUsers }
                     onlineMembersList
                     adminUuid={ privateChat.user_uuid }
                  />
               )
            }
            {
               (tipModalData.isTipModal || tipModalData.isLimitModal) && chatPanel.isOpen && (
                  <TipMeContainer
                     tipModalData={ tipModalData }
                     tipAction={ this.tipAction }
                  />
               )
            }

            {
               isOpenPurchaseModal && 'chat' === modalKey  && (
                  <>
                     {
                        !this.chatPeyParUsingOnlyWallet && (
                           <SendModal
                              id={ null }
                              usdTerms={ price }
                              type={ this.modalType }
                              onCloseSendModal={ (bool) => {
                                 this.payPerMessage = null;
                                 this.modalType = null
                                 const { type, randomid } = this.draftMessage
                                 if(randomid) {
                                    const {  deleteMessage } = this.props
                                    const messageData = {
                                       key: 'isDraft',
                                       type,
                                    }
                                    deleteMessage(messageData)
                                 }
                                 this.onCloseSendModal(bool);
                              } }
                              animateSend={ animateSend }
                              // mediaName='sss'
                              closeChat={ () => {
                                 if(screenWidth < 1025) {
                                    this.closeChatWhitRedirect()
                                 }
                              } }
                              updateMassMessageAfterPayment={ type => {
                                 if('wallet' === type){
                                    const { newData, type, randomid } = this.draftMessage
                                    this.handleSocketEmitSend(newData, type, randomid, true, (data) => {
                                       this.handleAddNewMessage({ ...this.darftNewMessage, ...newData, ...data }, type, true)
                                    })
                                 }
                                 const messageData = {
                                    key: 'isDraft',
                                    type,
                                 }
                                 deleteMessage(messageData)
                              } }
                              updateCallBackAfterRedirectPayment={ () => {
                                 const messageData = {
                                    key: 'isDraft',
                                    type,
                                 }
                                 deleteMessage(messageData)
                              } }
                              extraInfo={ { message: this.payPerMessage } }
                           />
                        )
                     }
                     {
                        this.chatPeyParUsingOnlyWallet && (
                           <WalletModal
                              type={ purchaseModalType }
                              isPaidMessage
                              balance={ walletBalance }
                              isMobile={ screenWidth < 701 }
                              height={ window.innerHeight }
                              onModalClose={ this.closeWalletPayModal }
                              chatSendTextPrice={ price }
                              selectedAmount={ selectedAmount }
                              onClickButton={ (data) => {
                                 if('top_up' === purchaseModalType) {
                                    this.topUpMyWallet(data)
                                 } else {
                                    paymentSend(
                                       { type: this.modalType },
                                       () => {
                                          const { newData, type, randomid } = this.draftMessage
                                          this.handleSocketEmitSend(newData, type, randomid, true, (data) => {
                                             this.handleAddNewMessage({ ...newData, ...data  }, type, true)
                                          })
                                       },
                                       {
                                          isOpenSendModal: false,
                                          isSend: false,
                                       },
                                       () => {
                                          const messageData = {
                                             key: 'isDraft',
                                             type,
                                          }
                                          deleteMessage(messageData)
                                       }
                                    )
                                 }
                              } }
                              isNotEnoughtBalance={ isNotEnoughtBalance }
                              isProgressing={ isFetchingWalletPayed }
                              isFetchingWallet={ isFetchingWalletAmount }
                              isFetchingBalance={ walletLimitModalData.isFetching }
                              hasPageHeader={ 'top_up' === purchaseModalType }
                              goToWalletTopUp={ this.goToWalletTopUp }
                              walletData={ amountData }
                              onSelectAmount={ this.onSelectAmount }
                              modalPosition={ 'top_up' === purchaseModalType ? 'full-screen' : 'bottom' }
                              memberUuid={ authUser.uuid }
                              animate={ walletModalAnimate }
                              adminScreenName={ siteInfo.admin_screen_name }
                              isAddProcessingFees={ isAddProcessingFees }
                              onChangeAddProcessingFees={ this.onChangeAddProcessingFees }
                           />
                        )
                     }
                  </>
               )
            }
            {
               (isOpenPurchaseModal && purchaseModalType === this.messageType) && (
                  <SendModal
                     id={ this.messageId }
                     usdTerms={ this.streamPrice }
                     type={ this.messageType }
                     unlockType={ this.messageUnlockType }
                     onCloseSendModal={ (bool) => this.onCloseSendModal(bool) }
                     animateSend={ animateSend }
                     mediaName={ data.title }
                     closeChat={ () => {
                        if(screenWidth < 1025) {
                           this.closeChatWhitRedirect()
                        }
                     } }
                     updateMassMessageAfterPayment={ this.promoMessage ? () => this.updateMassMessageAfterPayment() : null }
                     isChat
                  />
               )
            }
            {
               walletLimitModalData.isLimitModal && (
                  <LimitModal
                     title={ walletLimitModalData.header }
                     description={ walletLimitModalData.body }
                     onCancel={ this.onWalletModalClose }
                     isMobile={ screenWidth < 701 }
                     animate={ animateLimit }
                  />
               )
            }
         </>
      )
   }
}
const mapStateToProps = (state) => {
   return {
      screenWidth: screenWidthSelector(state),
      authUser: authUserSelector(state),
      isFetchingInit: isFetchingInitSelector(state),
      isFetchingMessage: isFetchingMessageSelector(state),
      isNextFetchingMessage: isNextFetchingMessageSelector(state),
      likedMemberByMessage: likedMemberByMessageSelector(state),
      siteInfo: siteInfoSelector(state),
      onlineUsers: onlineUsersSelector(state),
      isSocketConnected: isSocketConnectedSelector(state),
      groupChat: groupChatSelector(state),
      privateChat: privateChatSelector(state),
      settings: settingsSelector(state),
      groupChatTypersMessage: groupChatTypersMessageSelector(state),
      publicMessages: publicMessagesSelector(state),
      privateMessages: privateMessagesSelector(state),
      activeMessageTab: activeMessageTabSelector(state),
      showNavigationList: showNavigationListSelector(state),
      privateChatTypersMessage: privateChatTypersMessageSelector(state),
      mutedInfo: mutedInfoSelector(state),
      chatPanel: chatPanelSelector(state),
      inited: initedSelector(state),
      locationPath: currentLocationPathSelector(state),
      tipModalData: tipModalDataSelector(state),
      isCheckLimitFetching: isCheckLimitFetchingSelector(state),
      purchaseModalType: modalTypeSelector(state),
      isOpenPurchaseModal: isOpenSendModalSelector(state),
      isNotEnoughtBalance: isNotEnoughtBalanceSelector(state),
      isFetchingWalletPayed: isFetchingWalletPayedSelector(state),
      isPayedSuccess: isSendSelector(state),
      amountData: amountDataSelector(state),
      isFetchingWalletAmount: isFetchingWalletAmountSelector(state),
      modalKey: walletModalKeySelector(state),
      price: priceSelector(state),
      walletBalance: walletBalanceSelector(state),
      walletLimitModalData: walletLimitModalDataSelector(state),
      onlineStream: onlineStreamSelector(state),
      hiddeChatIcon: hiddeChatIconSelector(state),
      paymentButtonLoading: paymentButtonLoadingSelector(state),
      isFetchingLiveStreamMessages: isFetchingLiveStreamMessagesSelector(state),
      streamConversation: streamConversationSelector(state),
      currentLiveStream: currentLiveStreamSelector(state),
      paymentButtonResourceId: paymentButtonResourceIdSelector(state),
      isOfflineMode: isOfflineModeSelector(state),
      mainMessageId: mainMessageIdSelector(state),
      initLivestreamData: initLivestreamDataSelector(state),
   }
}

const mapDispatchToProps = (dispatch) => {
   return {
      onClickChat: bool => dispatch(onClickChat(bool)),
      init: () => dispatch(chatInitOperation()),
      fetchMessages: (id, data, inited, callback) => {
         dispatch(fetchMessagesOperation(id, data, inited, callback)) },
      fetchNextMessages: (id, page) => dispatch(fetchNextMessagesOperation(id, page)),
      fetchMessageLikedMembers: (id, page) => dispatch(fetchMessageLikedMembersOperation(id, page)),
      goTo: (location, search) => {
         dispatch(push({
            pathname: location,
            search,
         }))
      },
      setOnlineUsersAction: (members, action, fetch) => dispatch(setOnlineUsersAction(members, action, fetch)),
      setSocketConnectedAction: (bool) => dispatch(setSocketConnectedAction(bool)),
      setTyper: (data) => dispatch(chatInitCompleted(data)),
      setMessagLike: (data) => dispatch(setMessagLike(data)),
      deleteMessage: (data) => dispatch(deleteMessage(data)),
      addNewMessage: (data) => dispatch(addNewMessage(data)),
      updateMessageData: (id, data, type) => dispatch(updateMessageData(id, data, type)),
      updateConverstionData: (id, data) => dispatch(updateConverstionData({ id, data })),
      updatePrivateConversation: (id) => dispatch(updatePrivateConversation(id)),
      setMutedMemberInfo: data => dispatch(setMutedMemberInfo(data)),
      setChatPanel: data => {
         dispatch(setChatPanelAction(data))
      },
      setChatSettings: data => {
         dispatch(setChatSettings(data))
      },
      setActiveTab: data => {
         dispatch(setActiveTab(data))
      },
      setTipModalState: (data) => { dispatch(setTipModalState(data)) },
      paymentSend: (data, callback, modalData, errorCallback) => dispatch(paymentSend(data, callback, modalData, errorCallback)),
      setSendModalState: (data) => dispatch(setSendModalState(data)),
      initWalllet: modal => dispatch(initWalletOperation(modal)),
      updateWalletBalanc: modal => dispatch(updateWalletBalanc(modal)),
      getWalletBalance: () => { dispatch(getWalletBalanceOperation()) },
      checkWalletLimitStart: (data) => { dispatch(checkWalletLimitStart(data)) },
      checkWalletLimitCompleted: (data) => { dispatch(checkWalletLimitCompleted(data)) },
      checkWalletLimitFailed: (data) => { dispatch(checkWalletLimitFailed(data)) },
      setWalletLimitState: (data) => { dispatch(setWalletLimitState(data)) },
      fetchPurchaseMethods: (routeName, id, messageType, onlyWalletPay, mainMessageId) => { dispatch(fetchPurchaseMethodsOperation(routeName, id, messageType, onlyWalletPay, null, mainMessageId)) },
      downloadFile: (id) => dispatch(downloadMediaOperation(id, 'chat/messages')),
      openClosedConversation: (conversationId) => dispatch(openClosedConversationOperation(conversationId)),
      setIsOfflineModeAction: (data) => dispatch(setIsOfflineModeAction(data)),
      openPollModal: (callback) => dispatch(openActivePollModalOperation(callback)),
      closePollModal: () => dispatch(closePollModalAction()),
      openClosePollConfirmDialog: (type) => dispatch(openClosePollConfirmDialogAction(type)),
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatNotificationContainer);
